import { packsClient } from "lib/clients";
import { useRouter } from "next/router"
import useSWR from "swr";
import { useToastNotification } from ".";

const fetcher = async (_key, packId) => {
  const { data } = await packsClient.getPackShareTokens(packId);
  return data;
}

export const usePackShareTokens = (packId?: string) => {
  const { query: { id } } = useRouter();

  const pid = packId || id;

  const { data, error, isValidating, mutate } = useSWR(pid ? [`/v1/pack/share-tokens/${pid}`, pid] : null, fetcher);
  const { errorToast } = useToastNotification();

  const update = async (shareToken: any) => {
    try {
      const updateToken = {
        enabled: shareToken.enabled,
        team_share: shareToken.team_share,
        anon_enabled: shareToken.anon_enabled,
        index_enabled: shareToken.index_enabled
      }

      await packsClient.updateShareToken(shareToken.pack_id, shareToken.id, updateToken);

      await mutate();
    } catch (err) {
      errorToast({
        title: 'Error',
        description: 'Could not update share token'
      })
    }
  }

  return {
    data,
    isValidating,
    isLoading: !data && !error,
    error,
    update,
  }
};
